import { useTranslation } from 'react-i18next';

import { DROPDOWN_TRIGGER_CLEAR_BUTTON_CLASS } from '~/chords/DropdownTreeSingleSelect/styles';
import { Icon } from '~/chords/Icon';

export interface DropdownTriggerClearButtonProps {
  onClear?: () => void;
}

export function DropdownTriggerClearButton({
  onClear,
}: DropdownTriggerClearButtonProps) {
  const { t } = useTranslation('common');

  return (
    <button
      type="button"
      aria-label={t('dropdownTree.clearSelection')}
      onClick={(event) => {
        // We only want the clear button itself to handle clicks so stop the
        // event from bubbling up to the parent element.
        event.stopPropagation();
        onClear?.();
      }}
      className={DROPDOWN_TRIGGER_CLEAR_BUTTON_CLASS}
    >
      <Icon size="sm" type="xmark" aria-hidden />
    </button>
  );
}

DropdownTriggerClearButton.displayName = 'DropdownTriggerClearButton';
